import angular from 'angular';
import 'angular-ui-router';
import 'satellizer';
import Configs from '../../../configs/configs';
import Services from '../../../services/services';
import Resources from '../../../resources/resources';
import template from './passwordForgot.jade';

export class PasswordForgotController {
  constructor($filter, notify, $http, api){
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.notify = notify;
    this.$http = $http;
    this.api = api;

    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'email',
        templateOptions: {
          label: this.translate('email'),
          type: 'email',
          required: true,
          focus: true
        }
      }
    ];
  }

  requestPassword() {
    this.$http.post(`${this.api.baseURL}/oauth/token/v3/forgot-password`, {
      email: this.user.email
    }, {
      headers: { 'Requested-From-Component': 'pepapi-frontend'},
    })
      .then(() => {
        this.notify.success('requestedPassword');
      })
      .catch(this.notify.apiError)
  }
}

export function PasswordForgotComponent() {
  return {
    template,
    controller: PasswordForgotController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
}


export default angular.module('password.new', [
  Configs.name,
  Resources.name,
  Services.name,
])
  .directive('passwordForgot', PasswordForgotComponent)


/** WEBPACK FOOTER **
 ** ./src/components/account/password/passwordForgot.js
 **/